import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: config.VUE_APP_I18N_LOCALE || "fr",
  fallbackLocale: config.VUE_APP_I18N_FALLBACK_LOCALE || "fr",
});
